module.exports = __webpack_public_path__ + "img/blog-post-01.e2303a3b.jpg";